<template>
    <div id="FandyWidget" :class="{open: open}">
        <div class="widget-label" @click="open = !open">Поддержите нас!</div>
        <div class="widget-close" @click="open = false">x</div>
        <div id="fandy"></div>
    </div>
</template>

<script>


export default {
    name: "FandyWidget",
    data() {
        return {
            open: false
        }
    },
    mounted() {
        FandyWidget.init(77, 'fandy')
    }
}
</script>

<style lang="scss" scoped>
#FandyWidget {
    z-index: 10000;
    position: fixed;
    width: 400px;
    right: -405px;
    top: 20px;
    transition: right 400ms;
    max-width: calc(100% - 20px);

    @media (max-width: 420px) {
        width: 360px;
        right: -347px;
    }

    &.open {
        right: 10px
    }

    .widget-label {
        z-index: 9999;
        position: absolute;
        left: -99px;
        top: 30%;
        transform: rotate(-90deg);
        background: #f0f5fd;
        padding: 5px 10px;
        /* box-shadow: 0px -2px 6px 0 #e9e9e996; */
        border-radius: 10px 10px 0 0;
        cursor: pointer;
    }

    .widget-close {
        position: absolute;
        right: -5px;
        top: -5px;
        width: 20px;
        height: 20px;
        z-index: 10002;
        background-color: red;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        box-shadow: 0 0 3px 0 #ccc;
        cursor: pointer;
    }
}
</style>
